export default __webpack_public_path__ + "static/media/chevron_white.679f829d.svg";